import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

export const setSelectedProduct = createAction(actionType.SET_SELECTED_PRODUCT);
